/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CalculateRoyaltiesSettlementRequest,
  GetRoyaltiesSettlementParams,
  RoyaltiesCalculationResponse
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCalculateRoyaltiesSettlementUrl = () => {




  return `/api/RoyaltiesSettlement/CalculateRoyaltiesSettlement`
}

export const calculateRoyaltiesSettlement = async (calculateRoyaltiesSettlementRequest: CalculateRoyaltiesSettlementRequest, options?: Parameters<typeof customInstance>[1]): Promise<RoyaltiesCalculationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<RoyaltiesCalculationResponse>(getCalculateRoyaltiesSettlementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(calculateRoyaltiesSettlementRequest)
  }
);}





export const getCalculateRoyaltiesSettlementMutationKey = () => ['calculateRoyaltiesSettlement'] as const;

export const getCalculateRoyaltiesSettlementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateRoyaltiesSettlement>>, TError,CalculateRoyaltiesSettlementMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calculateRoyaltiesSettlement>>, TError,CalculateRoyaltiesSettlementMutationVariables, TContext> => {

const mutationKey = getCalculateRoyaltiesSettlementMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calculateRoyaltiesSettlement>>, CalculateRoyaltiesSettlementMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  calculateRoyaltiesSettlement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CalculateRoyaltiesSettlementMutationResult = NonNullable<Awaited<ReturnType<typeof calculateRoyaltiesSettlement>>>
    export type CalculateRoyaltiesSettlementMutationBody = BodyType<CalculateRoyaltiesSettlementRequest>
    export type CalculateRoyaltiesSettlementMutationError = ErrorType<unknown>
    export type CalculateRoyaltiesSettlementMutationVariables = {data: BodyType<CalculateRoyaltiesSettlementRequest>}

    export const useCalculateRoyaltiesSettlement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calculateRoyaltiesSettlement>>, TError,CalculateRoyaltiesSettlementMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calculateRoyaltiesSettlement>>,
        TError,
        CalculateRoyaltiesSettlementMutationVariables,
        TContext
      > => {
      return useMutation(getCalculateRoyaltiesSettlementMutationOptions(options), queryClient);
    }
    export const getGetRoyaltiesSettlementUrl = (params: GetRoyaltiesSettlementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/RoyaltiesSettlement/GetRoyaltiesSettlement?${stringifiedParams}` : `/api/RoyaltiesSettlement/GetRoyaltiesSettlement`
}

export const getRoyaltiesSettlement = async (params: GetRoyaltiesSettlementParams, options?: Parameters<typeof customInstance>[1]): Promise<Blob> => {

  return customInstance<Blob>(getGetRoyaltiesSettlementUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoyaltiesSettlementQueryKey = (params?: GetRoyaltiesSettlementParams,) => {
    return [
    `/api/RoyaltiesSettlement/GetRoyaltiesSettlement`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRoyaltiesSettlementQueryOptions = <TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoyaltiesSettlementQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoyaltiesSettlement>>> = ({ signal }) => getRoyaltiesSettlement(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoyaltiesSettlementQueryResult = NonNullable<Awaited<ReturnType<typeof getRoyaltiesSettlement>>>
export type GetRoyaltiesSettlementQueryError = ErrorType<unknown>


export function useGetRoyaltiesSettlement<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoyaltiesSettlement>>,
          TError,
          Awaited<ReturnType<typeof getRoyaltiesSettlement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoyaltiesSettlement<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoyaltiesSettlement>>,
          TError,
          Awaited<ReturnType<typeof getRoyaltiesSettlement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoyaltiesSettlement<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRoyaltiesSettlement<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoyaltiesSettlementQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetRoyaltiesSettlementSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoyaltiesSettlementQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoyaltiesSettlement>>> = ({ signal }) => getRoyaltiesSettlement(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetRoyaltiesSettlementSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRoyaltiesSettlement>>>
export type GetRoyaltiesSettlementSuspenseQueryError = ErrorType<unknown>


export function useGetRoyaltiesSettlementSuspense<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoyaltiesSettlementSuspense<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoyaltiesSettlementSuspense<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRoyaltiesSettlementSuspense<TData = Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError = ErrorType<unknown>>(
 params: GetRoyaltiesSettlementParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRoyaltiesSettlement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoyaltiesSettlementSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






